import { CaretDownIcon, CaretUpIcon } from '@/shared/ui/assets';
import { getFaqData } from '@/shared/config';
import { Collapse } from 'antd';
import _ from 'lodash';
import type { FrequentlyAskedQuestionsProps } from './frequentlyAskedQuestions.types';
import './frequentlyAskedQuestions.scss';

/**
 * Renders the Collapse panel's expand icon, swapping between the caret-up and caret-down images by the panel's open state.
 *
 * @param isActive - Whether the collapse panel is currently expanded.
 * @returns The expand icon element.
 */
const renderExpandIcon = ({ isActive }: { isActive?: boolean }) => (
  <img src={isActive ? CaretUpIcon : CaretDownIcon} alt="Expan Icon" />
);

/**
 * Renders the frequently asked questions tab of the support page. Only mounts when the tab is active, pulls the FAQ entries from the data helper and renders each as a collapsible card whose label is the question and whose body is the answer.
 *
 * @param isActive - Whether the FAQ tab is currently selected.
 * @returns The FAQ tab body, or a falsy value when inactive.
 */
const FrequentlyAskedQuestions = ({ isActive }: FrequentlyAskedQuestionsProps) => {
  /**
   * Renders the FAQ entries as one collapsible card per question. Each item becomes a collapse panel whose label is the question and whose body is the answer, with the expand icon swapping between the caret-up and caret-down images by open state.
   *
   * @param questions - FAQ entries, each carrying a question and an answer.
   * @returns The list of collapsible FAQ cards.
   */
  const questionsRenderer = (questions: any) =>
    _.map(questions, (item, index) => (
      <div key={index} className="faq-card">
        <Collapse
          expandIcon={renderExpandIcon}
          items={[
            {
              key: index,
              label: item.question,
              children: <span>{item.answer}</span>,
            },
          ]}
        />
      </div>
    ));

  const faqData = getFaqData();

  return (
    isActive && (
      <div className="support-tab faq-tab">
        <div className="support-tab__body">{questionsRenderer(faqData)}</div>
      </div>
    )
  );
};

export default FrequentlyAskedQuestions;
